import { SUPPORT_EMAIL } from '../config';

export const FAQS = [
  {
    q: 'Where does Revive meet?',
    a: 'Our whole thing is to worship in unlikely places. Revive Nights move around the greater Pittsburgh area, from parks to homes, colleges, and anywhere else. Our Unashamed experiences are currently held biannually at Schenley Plaza in Oakland. Follow us on Instagram for location drops.',
  },
  {
    q: 'What can I expect?',
    a: 'Jesus proclaimed. Authentic, Spirit-led worship. And people from all over Pittsburgh who are genuinely happy you showed up. It\'s that kind of vibe.',
  },
  {
    q: 'What age is Revive for?',
    a: 'If you love God, have a youthful spirit, and want to worship, you\'re exactly who we\'re gathering for.',
  },
  {
    q: 'What if I\'m coming alone?',
    a: 'Honestly? Same energy as showing up to a kickback where you only know the host, except everyone\'s friendlier than you\'d expect. Come.',
  },
  {
    q: 'Does it cost anything?',
    a: 'Free. Always has been, always will be.',
  },
  {
    q: 'Is Revive part of a church?',
    a: 'Nope. Revive is an independent worship ministry that exists alongside the church, not in place of it. We deeply believe in the local church and see ourselves as something that points people toward it, not away from it.',
  },
  {
    q: 'Is Revive accountable to anyone?',
    a: 'Yes, and we think that matters. Revive is led by and accountable to a team of trusted elders with a demonstrated track record of faithful, healthy leadership at home and in the church. We don\'t take that lightly.',
  },
  {
    q: 'What does Revive believe?',
    a: 'We hold to the historic Christian faith. One God in three persons (Father, Son, and Holy Spirit), the deity and resurrection of Jesus Christ, salvation by grace through faith in Him alone, and the call to live as His followers in the power of the Spirit.',
  },
  {
    q: 'What is our take on the Bible?',
    a: 'We believe the canonical Bible is divinely inspired, for instruction, correction, and the equipping of every believer. The Bible is God\'s story anchored in the context of history. It is our authority, our conscience, and our guide. We are firm where it is firm, and we are flexible where it is flexible.',
  },
  {
    q: 'How do I serve with Revive?',
    a: `We'd love to have you. Shoot us an email at ${SUPPORT_EMAIL} and tell us a little about yourself.`,
  },
];
